import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashDisabled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.59922 0.800781V2.40078H12.7992V4.00078H3.19922V2.40078H6.39922V0.800781H9.59922Z",
			fill: "black",
			fillOpacity: .38
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.99961 15.201L3.19961 4.80098H12.7996L11.9996 15.201H3.99961ZM11.0604 6.40098H4.93881L5.47161 13.601H10.5276L11.0604 6.40098Z",
			fill: "black",
			fillOpacity: .38
		})
	]
});
const ForwardRef = forwardRef(SvgTrashDisabled);
export { ForwardRef as ReactComponent };
